/**
 * Helper centralizzati per i permessi basati sul ruolo utente.
 *
 * Modello: il RUOLO decide cosa si VEDE, l'ASSEGNAZIONE decide cosa si SCRIVE.
 * I ruoli di sola lettura vedono tutto (incluso DMA e Raccolta Dati) ma non
 * possono creare/modificare/eliminare; le eventuali scritture consentite dove
 * sono assegnati sono governate a parte (assegnazione owner/validator/assessor).
 */
import type { Ruolo } from '@teamsystem-impact/shared';

/** Ruoli di sola lettura (vedono tutto, non modificano). Allineato al backend READ_ONLY_ROLES. */
export const READ_ONLY_ROLES: Ruolo[] = ['visualizzatore', 'legal_reviewer'];

/** true se il ruolo è di sola lettura. */
export function isReadOnlyRole(ruolo?: Ruolo | string | null): boolean {
  return !!ruolo && (READ_ONLY_ROLES as string[]).includes(ruolo);
}

/** true se il ruolo può eseguire operazioni di scrittura "da gestore" (non read-only). */
export function canWrite(ruolo?: Ruolo | string | null): boolean {
  return !isReadOnlyRole(ruolo);
}
